export default __webpack_public_path__ + "static/media/IkonHelbredsoplysninger.fbcea3e1.svg";